export default __webpack_public_path__ + "./images/ph.6fcc2dd1.png";